import { FC } from 'react';
import { JobDetailResponse, JobResponse } from '@doda/api-client/aspida/@types';
import { StructuredData } from '@doda/common/src/components/JobSearchDetail/StructuredData';
import type { Tab } from '../../types/tab';
import { useTab } from '../TabArea/hooks/useTab';

/**
 * JobPostingのProps
 */
export interface Props {
  jobSearchDetail: JobDetailResponse;
  initialTab: Tab;
  isScout: boolean;
  jid: string;
  wcnsId: JobResponse['wcnsId'];
}

/**
 * JobPosting構造化データコンポーネント
 * @param {JobDetailResponse} jobSearchDetail 求人詳細APIレスポンス値
 * @param {Tab} initialTab タブの初期状態
 * @param {boolean} isScout スカウト求人の有無
 * @param {jid} string 求人ID
 * @param {JobResponse['wcnsId']} wcncId 原稿種別
 */
export const JobPosting: FC<Props> = ({
  jobSearchDetail,
  initialTab,
  isScout,
  jid,
  wcnsId,
}) => {
  const { job } = jobSearchDetail;

  const { currentTabName } = useTab({
    initialTab,
    jid,
    wcnsId: wcnsId || '',
  });

  // スカウト求人の場合はjobPosting非表示
  if (isScout) return null;
  // TMST407(GFJ除外案件マスタ)の確認
  if (!job?.googleForJobs?.canPublish) return null;
  // 求人詳細タブのときだけ構造化データを作成・表示する
  if (currentTabName !== 'jd') return null;

  return <StructuredData jobSearchDetail={jobSearchDetail} />;
};
